import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import Wrapper from "../components/Common/Wrapper"
import Content from "../components/Common/Content"
import { TextSm, TitleSm } from "../components/Text"
import Map from "../components/Map"
import text from "../data/text.json"

const DirectionsPage = () => (
  <Layout>
    <SEO title="Work" />
    <Wrapper>
      <Content>
        <TitleSm style={{marginBottom: 0}}>{text.directions.title}</TitleSm>
      </Content>
    </Wrapper>
    <Map />
    <Wrapper>
      <Content>
        <TextSm>{text.directions.mainText}</TextSm>
      </Content>
    </Wrapper>
  </Layout>
)

export default DirectionsPage
